/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class StockEnquiryHistoryEditor extends _Ext.GridEditorBase<StockItemRow> {
        protected override getColumnsKey() { return "Stock.HistoryDetails"; }
     
        constructor(container: JQuery) {
            super(container);
        }
        //private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //this.autoSize = new Slick.AutoColumnSize();
            //grid.registerPlugin(this.autoSize);
            grid.setSelectionModel(new Slick.RowSelectionModel());


            return grid;
        }
        protected override getColumns() {

            var columns = super.getColumns();
            return columns;
        }
        //protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //    super.onClick(e, row, cell);


        //    if (e.isDefaultPrevented())
        //        return;

        //    //set selected row line no and BOM selection
        //    this.slickGrid.setSelectedRows([row]);

        //    var item = this.itemAt(row); 

        //    var target = $(e.target);

        //    // if user clicks "i" element, e.g. icon

        //    this.view.refresh();

        //}
         
        public setdata(bomdetails: any[]) {
            this.view.setItems([]);


            for (let Itemdetail of bomdetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }
        //public setselectedrow() {

        //    this.slickGrid.setSelectedRows(0);
        //}
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        }
    }
}